module.exports = __webpack_public_path__ + "img/Recurso 21@300x.de5e1f1b.png";